import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import EquipmentTable from "../EquipmentTable"
import EquipmentFilters from "../EquipmentFilters"
import styles from "./index.module.css"

const AvailableEquipmentSection = ({
  equipment,
  selectedCategories,
  onAssign,
  onCategoryChange,
  onClose,
  categoryOptions,
  canEdit,
  assignLoading
}) => {
  const { t } = useTranslation()

  const handleAssign = (item) => {
    onAssign(item)
  }

  return (
    <div className={styles.addEquipmentSection}>
      <Flex vertical gap={24}>
        <Flex align="center" justify="space-between">
          <div>
            <Flex align="center" gap={8} className="mb-xs">
              <Text fw={600} size="xl">
                {t("booking.equipment.available_equipment")}
              </Text>
              <Text className={styles.countText}>({equipment.length})</Text>
            </Flex>
            <Text className={styles.descriptionText}>{t("booking.equipment.available_equipment_description")}</Text>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseOutlined />
          </button>
        </Flex>

        <EquipmentFilters
          selectedCategories={selectedCategories}
          onCategoryChange={onCategoryChange}
          categoryOptions={categoryOptions}
        />

        <Flex vertical gap={12}>
          <EquipmentTable
            equipment={equipment}
            onAction={handleAssign}
            actionType="assign"
            emptyMessage={t("booking.equipment.no_available_equipment")}
            canEdit={canEdit}
            loading={assignLoading}
          />
        </Flex>
      </Flex>
    </div>
  )
}

AvailableEquipmentSection.propTypes = {
  equipment: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      equipmentId: PropTypes.number.isRequired,
      assetId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assetNumber: PropTypes.string.isRequired,
      maxGuests: PropTypes.number,
      category: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAssign: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  canEdit: PropTypes.bool,
  assignLoading: PropTypes.bool
}

export default AvailableEquipmentSection
